// extracted by mini-css-extract-plugin
module.exports = {"box":"box___3RaZQ","reverse":"reverse___rCBFd"};